import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** ありなし */
enum Existence {
  presence = 'presence',
  absence = 'absence',
}

const nameConfig = {
  presence: new Map([
    [Locale.ja, 'あり'],
    [Locale.en, 'Has Admin'],
  ]),
  absence: new Map([
    [Locale.ja, 'なし'],
    [Locale.en, 'Not Admin'],
  ]),
};

const toEnum = rawValueToEnum(Existence, Existence.presence);
const toDisplay = enumToName(Existence, nameConfig);
const toDisplayWithPrefix = enumToName(Existence, nameConfig, { prefix: true });

export const existence = {
  enum: Existence,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { Existence };
